import React from 'react';
import { FIRM } from '../data/siteData';
       import { Link } from 'react-router-dom';


const SOCIAL = [
  { label: 'Facebook',  href: 'https://facebook.com/SqamerLawFirm', icon: 'fb' },
  { label: 'Instagram', href: 'https://instagram.com/YourProfile', icon: 'ig' },
  { label: 'LinkedIn',  href: 'https://www.linkedin.com/in/shahzada-qamer/', icon: 'in' },
];

const WHATSAPP_NUMBER = '923009439703';
const WHATSAPP_MESSAGE = encodeURIComponent(
`Assalamu Alaikum! 👋

I came across S.Qamer & Co. and would like to request a *Free Consultation*.

🏛️ *S.Qamer & Co.* | Tax · Legal · Corporate · Immigration

I am interested in the following service(s):

1️⃣ Tax Matters (NTN, Returns, Appeals)
2️⃣ Legal Matters (Criminal, Civil, Family)
3️⃣ Corporate (Company Registration, SECP)
4️⃣ Immigration (Visa, Study, Skilled)

Kindly guide me at your earliest convenience.

Thank you! 🙏`
);
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;


export default function TopBar() {
  return (
    <div className="bg-navy text-white/80 text-xs py-2.5 px-[5%] flex flex-wrap justify-between items-center gap-3">

      {/* LEFT */}
      <div className="flex items-center gap-4 flex-wrap">
        {/* Phone with icon */}
        <div className="flex items-center gap-2">
          <span className="text-gold text-base">📞</span>
          <strong className="text-white text-sm">{FIRM.phone}</strong>
        </div>
        
        <span className="text-white/20">|</span>
        
        {/* Email with icon */}
        <div className="flex items-center gap-2">
          <span className="text-gold text-base">✉️</span>
          <a href={`mailto:${FIRM.email}`} className="text-gold-light hover:underline text-sm">
            {FIRM.email}
          </a>
        </div>
        
        <span className="text-white/20">|</span>

        {/* Social Icons - Bigger */}
        <div className="flex items-center gap-2">
          {SOCIAL.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              title={s.label}
              style={{
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                background: 
                  s.label === 'Facebook'  ? '#1877F2' :
                  s.label === 'Instagram' ? 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)' :
                  s.label === 'LinkedIn'  ? '#0A66C2' : '#333',
                color: '#ffffff',
                transition: 'all 0.3s ease',
                textDecoration: 'none',
                boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'scale(1.2)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';
              }}
            >
              {s.label === 'Facebook' && (
                <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: '16px', height: '16px' }}>
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              )}
              {s.label === 'Instagram' && (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '16px', height: '16px' }}>
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
                </svg>
              )}
              {s.label === 'LinkedIn' && (
                <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: '16px', height: '16px' }}>
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4V9h4v1.5a6 6 0 0 1 4-1.5z"/>
                  <rect x="2" y="9" width="4" height="12"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              )}
            </a>
          ))}
        </div>
      </div>

      {/* RIGHT */}
      <div className="flex items-center gap-5 flex-wrap">
        {/* Hours with icon */}
        <div className="flex items-center gap-1.5">
          <span className="text-gold text-base">🕐</span>
          <span className="text-white/90 text-sm">Mon–Sat: 9am – 6pm</span>
        </div>
        
        {/* Location with icon */}

<div className="flex flex-col items-center gap-1">
<div className="flex items-center gap-2">
  <span className="text-white text-base">📍</span>
  <Link 
    to="https://www.google.com/maps/place/S.+Qamer+%26+Co/@31.5436097,74.3167574,17z/data=!3m1!4b1!4m6!3m5!1s0x391904a6bb13f4e1:0xee557fd7983c12f8!8m2!3d31.5436097!4d74.3167574!16s%2Fg%2F11bwqfvvvz?entry=ttu&g_ep=EgoyMDI2MDQyMi4wIKXMDSoASAFQAw%3D%3D"
    className="hover:opacity-80 transition-opacity rounded-xl px-3 py-1.5"
    style={{ backgroundColor: '#8B0000' }}
  >
    <span className="text-white text-sm">Office Location</span>
  </Link>
</div>
</div>

        {/* WhatsApp Button - Bigger */}
        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-gradient-to-r from-green-600 to-green-500 text-white px-4 py-1.5 text-xs font-semibold uppercase tracking-wider hover:from-green-700 hover:to-green-600 transition-all duration-300 flex items-center gap-2 rounded-full shadow-md hover:shadow-lg"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
            <path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.118 1.522 5.853L.057 23.57a.75.75 0 0 0 .92.92l5.718-1.465A11.945 11.945 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.708 9.708 0 0 1-4.953-1.355l-.355-.212-3.674.941.957-3.593-.232-.369A9.75 9.75 0 1 1 12 21.75z"/>
          </svg>
          <span>Free Consultation</span>
        </a>
      </div>

      {/* Add style for Instagram gradient */}
      <style jsx>{`
        .instagram-gradient {
          background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%);
        }
      `}</style>
    </div>
  );
}